module.exports = __webpack_public_path__ + "static/djinni-mtg_afr-6a81275936f2e50111438e6d710c7dd8.jpg";